import { render, staticRenderFns } from "./AppointmentBook.Dialog.vue?vue&type=template&id=4d23397d&scoped=true"
import script from "./AppointmentBook.Dialog.vue?vue&type=script&lang=js"
export * from "./AppointmentBook.Dialog.vue?vue&type=script&lang=js"
import style0 from "./AppointmentBook.Dialog.vue?vue&type=style&index=0&id=4d23397d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d23397d",
  null
  
)

export default component.exports